import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { ThreeBounce } from 'better-react-spinkit'

import PlaceField from '../../PlaceField/PlaceField'

import addressFormContainer from './addressFormContainer'
import './AddressForm.css'

let AddressForm = ({
  busy,
  handleSubmit,
  onAddressSelect,
  submitting,
}) => (
  <form onSubmit={handleSubmit} className="AddressForm">
    <label htmlFor="address" className="sr-only">Address</label>
    <Field
      className="form-control mr-sm-2 AddressForm__input"
      component={PlaceField}
      id="address"
      name="address"
      onSelect={onAddressSelect}
      placeholder={`e.g., ${process.env.REACT_APP_PLACEHOLDER_ADDRESS}`}
      required
      type="text"
    />
    <button
      className="btn btn-primary AddressForm__btn"
      disabled={busy || submitting}
      type="submit"
    >
      {(busy || submitting) ? <ThreeBounce color='#fff' size={12} /> : 'Update'}
    </button>
  </form>
)

export default addressFormContainer(
  reduxForm({ form: 'addressForm' })(AddressForm)
)


// WEBPACK FOOTER //
// ./src/components/Nav/AddressForm/AddressForm.js